import { isNil, isPlainObject } from 'lodash';
import { type ITranslationKey } from '../../ITranslationKey.ts';
import { type ITranslationSchema } from '../TranslationSchema.ts';
import {
  BaseTranslationSchema,
  type ITranslationUpdateContext,
  TranslationSchemaType,
} from './BaseTranslationSchema.ts';

/**
 * Schema di traduzione per oggetti con chiavi dinamiche (keyed object).
 * Rappresenta strutture tipo `Record<string, T>`.
 *
 * Esempi:
 *   keyedObject(object({ customMessage: string() })) → { 'xyz123': { customMessage: 'abc' } }
 *   keyedObject(string()) → { '<chiave>': '<valore stringa>' }
 */
export class TranslationKeyedObjectSchema extends BaseTranslationSchema {
  type = TranslationSchemaType.KeyedObject;

  constructor(private valueSchema: ITranslationSchema) {
    super();
  }

  extract(value: any, path = '', prefix = ''): ITranslationKey[] {
    if (!isPlainObject(value)) return [];

    return Object.entries(value as Record<string, unknown>)
      .filter(([, v]) => !isNil(v))
      .flatMap(([key, v]) =>
        this.valueSchema.extract(v, `${path}.${key}`, `${prefix}.${key}`),
      );
  }

  translateValue(
    value: any,
    path: string,
    prefix: string,
    ctx: ITranslationUpdateContext,
  ): void {
    if (!isPlainObject(value)) return;

    Object.entries(value as Record<string, unknown>)
      .filter(([, v]) => !isNil(v))
      .forEach(([key, v]) =>
        this.valueSchema.translateValue(
          v,
          `${path}.${key}`,
          `${prefix}.${key}`,
          ctx,
        ),
      );
  }
}
